<app-CutomerKarshnasForm
[inner_Customer]="inner_Customer"
(outter_KarshnasMasol)="set_KarshnasMasol($event)">

</app-CutomerKarshnasForm>

<button *ngIf="!Proccesing_OnSubmitForm_Csutomer" type="button"
  (click)="OnSubmitFormCustomer()"  class="btn btn-danger"
  style="margin-left: 5px;"><i class="fa  fa-edit"></i> تایید و ویرایش نهایی اطلاعات مشتری </button>
<button *ngIf="Proccesing_OnSubmitForm_Csutomer" type="button" class="btn btn-info"
  style="margin-left: 5px;"> لطفا صبر نمائید ... <i class="fa fa-spin fa-spinner"></i> </button>
